import APIManager from "modules/common/apiManager";
import { Spinner } from "modules/common/components";
import { MainWrapper, Navigation } from "modules/theme";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Provider, connect } from "react-redux";
import { withRouter } from "react-router";
import { Redirect, Route } from "react-router-dom";
import { globalAction } from "store/action";
import { globalStateSelector } from "store/selector";
import DialpadWidget from "./dialpad/components/DialpadWidget";
import { EventManager } from "./dialpad/components/layout";
import { localStore } from "./helpers";
import { isAccess, permissionUrlKeys } from "./modules/common/utils";
import { permissionAdminObject } from "./modules/theme/theme1/common/components/CommonPermission/PermissionAdminObject";
import store from "./store";

export class PrivateRoutes extends Component {
  constructor(props) {
    super(props);
    this.redirectToLogin = this.redirectToLogin.bind(this);
    this.redirectToOrganisation = this.redirectToOrganisation.bind(this);
    this.autheticatedRoute = this.autheticatedRoute.bind(this);
    this.getUser = this.getUser.bind(this);
    this.getOrganisation = this.getOrganisation.bind(this);
    this.errorShowAndLogout = this.errorShowAndLogout.bind(this);
    this.mAPI = new APIManager();
    this.state = {
      loading: true,
      error: "",
    };
  }

  redirectToLogin() {
    return <Redirect to="/sign-in" />;
  }

  redirectToOrganisation() {
    return (
      <Redirect
        to={{ pathname: "/organization", state: { from: this.props.location } }}
      />
    );
  }
  autheticatedRoute(Component, props) {
    const { isDuplicatePage, isMaxUser } = this.props;

    return (
      <React.Fragment>
        <Provider store={store}>
          <EventManager>
            <MainWrapper>
              <Navigation />
              <Component {...props} />
              {!isDuplicatePage && !isMaxUser && <DialpadWidget />}
            </MainWrapper>
          </EventManager>
        </Provider>
      </React.Fragment>
    );
  }
  async getUser(updateObj) {
    const { dynamicUpdate } = this.props;

    this.mAPI.sendGetAPI(
      `auth/profile`,
      (data) => {
        if (data) {
          if (updateObj && Array.isArray(updateObj)) {
            updateObj.push({ key: "currentUser", value: data });
            updateObj.push({ key: "loginToken", value: data._id });
          }
          if (data.accessDefination) {
            updateObj.push({
              key: "accessDefination",
              value: data.accessDefination,
            });
          }
          dynamicUpdate(updateObj);
        }
        this.setState({ loading: false });
      },
      (error, data) => {
        this.errorShowAndLogout(`We didn't Found User Information`);
      },
      "private"
    );
  }

  async getProfile() {
    const { dynamicUpdate } = this.props;

    this.mAPI.sendGetAPI(
      `auth/profile`,
      (data) => {
        if (data) {
          dynamicUpdate({ key: "currentUser", value: data });
          dynamicUpdate({ key: "loginToken", value: data._id });
          if (data.accessDefination) {
            dynamicUpdate({
              key: "accessDefination",
              value: data.accessDefination,
            });
          }
          this.setState({ loading: false });
        }
      },
      (error, data) => {
        this.mAPI.clearStorage();
      },
      "public"
    );
  }
  getAccessUrl(companyName) {
    this.mAPI.sendGetAPI(
      `company/new/${companyName}`,
      (origanisation) => {
        const updateObj = { key: "accessUrl", value: origanisation.accessUrl };
        try {
          if (origanisation && origanisation.accessUrl) {
            this.mAPI.updateUrl(origanisation.accessUrl, companyName);
            this.getOrganisation(companyName, updateObj);
          } else {
            this.mAPI.clearStorage();
          }
        } catch (error) {
          this.mAPI.clearStorage();
        }
        // Alert.success(`Tenant Selected.`);
      },
      (error, data) => {
        if (data && data.message) {
          // Alert.error(`${data.message}`);
        } else {
          // Alert.error(`Tenant not found!!!`);
        }
      },
      "public"
    );
  }
  async getOrganisation(companyName, updateObjRecv) {
    this.mAPI.sendGetAPI(
      `tenant/details`,
      (data) => {
        const updateObj = [
          {
            key: "origanisation",
            value: data.detail || {},
          },
          {
            key: "data",
            value: data.detail || {},
          },
          { key: "accessUrl", value: data.accessUrl },
          {
            key: "socketUrl",
            value: data.socketUrl || "",
          },
          {
            key: "sipUrl",
            value: data.cpassUrl || "wss://cpaas-j.streamspace.ai",
          },
        ];
        if (updateObjRecv) {
          updateObj.push(updateObjRecv);
        }
        if (data && data.accessUrl) {
          localStore.setItem("selected-tenant", companyName);
          if (
            data.endPoints &&
            data.endPoints[0] &&
            data.endPoints[0].endPoint
          ) {
            updateObj.push({
              key: "sipDomain",
              value: data.endPoints[0].endPoint || "",
            });
          }
          if (data.regionDetail) {
            updateObj.push({
              key: "regionDetail",
              value: data.regionDetail || {},
            });
          }
          if (data.detail && data.detail.timeZone) {
            localStorage.setItem(
              "timezone",
              JSON.stringify({
                value: data.detail.timeZone,
                label: data.detail.timeZone,
                isInTree: true,
              })
            );
          }
          if (data.detail && data.detail.filterDuration) {
            localStorage.setItem("filterDuration", data.detail.filterDuration);
          }
          this.mAPI.updateUrl(data.accessUrl, companyName);
          // dynamicUpdate(updateObj);
          this.getUser(updateObj);
        }
      },
      (error, data) => {
        this.errorShowAndLogout(`Organisation Processing ERROR`);
      },
      "private"
    );
  }
  errorShowAndLogout(msg) {
    let _this = this;
    this.mAPI.clearStorage();
    this.setState({ error: msg || "We are facing issue in login" });
    setTimeout(() => {
      _this.redirectToLogin();
    }, 3000);
  }

  checkForUrlAccess(arr) {
    let isUrlAccess = true;
    const access = this.props.accessDefination;

    for (let i = 0; i < arr.length; i++) {
      let key;
      if (permissionUrlKeys[arr[i]]) {
        key = permissionUrlKeys[arr[i]];
      } else {
        key = arr[i];
      }
      if (typeof key === "object") {
        isUrlAccess = this.checkForUrlAccess(key);
      } else if (access && access[key]) {
        let isAcc = isAccess(access[key].options, ["list", "allow-view"]);
        if (isAcc === true) {
          isUrlAccess = true;
          break;
        } else {
          isUrlAccess = false;
        }
      }
    }

    return isUrlAccess;
  }

  render() {
    const {
      component: Component,
      permissionKey,
      loginToken,
      dynamicUpdate,
      accessUrl,
      socketUrl,
      ...rest
    } = this.props;
    const { error } = this.state;
    const isLoggedIn = localStore.getItem("token");
    const pathname = this.props.location.pathname.toLowerCase();
    const pathArray = pathname.split("/");
    let { currentUser } = this.props;
    currentUser = currentUser || {};
    let agentRole = currentUser.role || '';
    pathArray.shift();
    let arr = this.props.arr2;
    if (!arr) {
      dynamicUpdate({ key: "arr2", value: {} });
    }
    if (arr && !arr[this.props.path]) {
      arr[this.props.path] = "";
      dynamicUpdate({ key: "arr2", value: arr });
    }

    return (
      <Route
        {...rest}
        exact
        render={(props) => {
          const tenantName = localStore.getItem("selected-tenant");

          if (agentRole == 5) {
            if (pathname == "/settings/phonenumbers" ||
              pathname == "/settings/providers" ||
              pathname == "/settings/flow") {
              return <Redirect to="/not-found" />;
            } else {
              return this.autheticatedRoute(Component, props);
            }
          }

          if (error) {
            return (
              <div className="row">
                <div className="col-md-12 text-center">
                  <h5>{error}</h5>
                </div>
              </div>
            );
          } else if (isLoggedIn) {
            const pathname = (props.location && props.location.pathname) || "";
            console.log('pathname', pathname)
            if (this.checkForUrlAccess(pathArray) === true) {
              if (
                tenantName ||
                pathname === "/organization" ||
                pathname === "/billing" ||
                pathname === "/organization-settings" ||
                pathname === "/organization-settings/region" ||
                pathname === "/organization-settings/flow-template" ||
                pathname === "/organization-settings/tts-provider" ||
                pathname === "/organization-settings/tts-model" ||
                pathname === "/organization-settings/stt-provider" ||
                pathname === "/organization-settings/stt-model" ||
                pathname === "/organization-settings/llm-provider" ||
                pathname === "/organization-settings/llm-model"
              ) {
                if (
                  pathname == "/organization" ||
                  pathname == "/billing" ||
                  pathname == "/organization-settings" ||
                  pathname == "/organization-settings/region" ||
                  pathname == "/organization-settings/flow-template" ||
                  pathname === "/organization-settings/tts-provider" ||
                  pathname === "/organization-settings/tts-model" ||
                  pathname === "/organization-settings/stt-provider" ||
                  pathname === "/organization-settings/stt-model" ||
                  pathname === "/organization-settings/llm-provider" ||
                  pathname === "/organization-settings/llm-model"
                ) {
                  if (this.state.loading) {
                    this.getProfile();
                    return <Spinner />;
                  } else {
                    return this.autheticatedRoute(Component, props);
                  }
                } else {
                  if (loginToken && socketUrl) {
                    return this.autheticatedRoute(Component, props);
                  } else {
                    if (this.state.loading) {
                      if (accessUrl) {
                        this.getOrganisation(tenantName);
                      } else {
                        this.getAccessUrl(tenantName);
                      }
                      return <Spinner />;
                    } else {
                      return this.autheticatedRoute(Component, props);
                    }
                  }
                }
              } else {
                return this.redirectToOrganisation();
              }
            } else {
              return <Redirect to="/forbidden" />;
            }
          } else {
            return this.redirectToLogin();
          }
        }}
      />
    );
  }
}
PrivateRoutes.contextTypes = {
  __: PropTypes.func,
};

const stateToProps = (state) => ({
  loginToken: globalStateSelector.getDynamic(state, { key: "loginToken" }),
  isDuplicatePage: globalStateSelector.getDynamic(state, {
    key: "isDuplicatePage",
  }),
  isMaxUser: globalStateSelector.getDynamic(state, { key: "isMaxUser" }),
  currentUser: globalStateSelector.getDynamic(state, { key: "currentUser" }),
  accessDefination: globalStateSelector.getDynamic(state, {
    key: "accessDefination",
  }),
  arr2: globalStateSelector.getDynamic(state, {
    key: "arr2",
  }),
  accessUrl: globalStateSelector.getDynamic(state, {
    key: "accessUrl",
  }),
  socketUrl: globalStateSelector.getDynamic(state, {
    key: "socketUrl",
  }),
});

const dispatchToProps = (dispatch) => ({
  dynamicUpdate: (data) => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
});
export default withRouter(
  connect(stateToProps, dispatchToProps)(PrivateRoutes)
);



// WEBPACK FOOTER //
// src/PrivateRoutes.js